export default {
  Community: {
    title: "Сообщество",
    description: "Обмен знаниями между врачами по клиническим случаям",
    all_cases: "Все кейсы",
    my_cases: "Мои кейсы",
    case: {
      shareLink: {
        1: "Посмотрите кейс",
        2: "на Платформе “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
  },
  h1_community: "Сообщество врачей",
};
